import { FileEarmarkImageFill } from 'react-bootstrap-icons';

interface ImageContainerProps {
    img_url: string;
}

function ImageContainer({img_url}: ImageContainerProps){
    return (
        /* Need to write code to capture half stars */
        <> 
            {img_url ? <img className="square-image-block" src={img_url} /> : <div className="style-center-child"><div><FileEarmarkImageFill className="square-image-block brand-primary-font-color" size={40} /></div></div> }
        </>
    )
}

export default ImageContainer;